import { useTranslation } from '@digitalfemsa/cronos/i18n';
import { HeadUniversal } from 'app/pages/frames/components/HeadUniversal/HeadUniversal';
import { favicon } from 'app/util/constants';

import type { FC } from 'react';

interface SharableMetadataProps {
  merchantName: string;
  paymentReason: string;
}
export const SharableMetadata: FC<SharableMetadataProps> = ({ merchantName, paymentReason }) => {
  const { t } = useTranslation();
  return (
    <HeadUniversal>
      {/* DigitalFemsaSource.PAYMENT_LINK or DigitalFemsaSource.REDIRECT */}
      <link rel='icon' href={favicon} />
      <meta property='og:title' content={t('hostedCheckout.metadata.paymentLinkFrom', { merchantName })} />
      <meta property='og:url' content='https://oxxo.com/' />
      <meta property='og:description' content={t('hostedCheckout.metadata.paymentReason', { paymentReason })} />
      <meta
        property='og:image'
        content='https://assets-prd.digitalfemsa.io/cpanel/statics/assets/brands/logos/conekta-c.png'
      />
    </HeadUniversal>
  );
};
